import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import AvatarImg from '../../../../public/images/empresa.png';

const Circular = props => (
  <div className="container-detail-circular">
    <div className="circular-img">
      <img src={AvatarImg} />
    </div>
    <span className="circular-text yellow">20%</span>
    <h3 className="circular-text-bajada">
      {props.language.detail_waiting_times.fufillment.acomplishment}
    </h3>
    <div className="circular-arrow">
      <span className="circular-arrow-indicators green">
        <i className="fas fa-arrow-up fa-2x" />
      </span>{' '}
      <span className="circular-arrow-text green">10%</span>
    </div>
    <div className="circular-modal-indicators">
      <a>
        <i className="fas fa-question-circle" />
        <div>
          <h6 className="green">10% {props.language.detail_waiting_times.fufillment.bestPeriod}</h6>
          <p>
            {props.language.detail_waiting_times.fufillment.befor} (31-05 al 13/06){' '}
            <span className="red">10%</span>
          </p>
          <p>
            {props.language.detail_waiting_times.fufillment.now} (14-06 al 27/06){' '}
            <span className="yellow">80%</span>
          </p>
        </div>
      </a>
    </div>

    <div className="circular-graph-line">
      <a>
        <i className="fas fa-question-circle" />
        <div className="circular-graph-line-container">
          <h6>{props.language.detail_waiting_times.fufillment.howItGoes}</h6>
          <div className="circular-graph-line-bar">
            <span className="text1">0%</span>
            <span className="text2">100%</span>
            <span className="text3">50%</span>
            <span className="text4">85%</span>
            <span className="text5">{props.language.detail_waiting_times.fufillment.goal}</span>
            <span className="text6" />
            <span style={{ left: '10%' }} className="text7">
              <i className="fas fa-truck" />
            </span>
            <div style={{ width: '50%' }} className="red" />
            <div style={{ width: '35%' }} className="yellow" />
            <div style={{ width: '15%' }} className="green" />
          </div>
        </div>
      </a>
    </div>

    <CircularProgress
      className={'circular-yellow'}
      variant="static"
      value={80}
      thickness={3}
      size={100}
    />
    <CircularProgress
      className={'circular-2'}
      variant="static"
      value={100}
      thickness={3}
      size={100}
    />
  </div>
);

export default Circular;



// WEBPACK FOOTER //
// ./source/client/components/detail_fulfillment/circular.jsx